module.exports = __webpack_public_path__ + "img/product3.db670394.png";